import React from 'react';
import Moment from 'moment-timezone';
import './EndorsementCard.scss';
import { DISPLAY_DATE_FORMAT } from 'Util/Constants/Common';
import EndorsementDtoReadonly from 'Models/Endorsement/Dto/EndorsementDto';

interface EndorsementCardProps {
   endorsement: EndorsementDtoReadonly;
}
export const ENDORSEMENT_TYPE_PLUMBER = 'SCEP';

const EndorsementCard = ({ endorsement }: EndorsementCardProps): JSX.Element => {

   const expiryDate = endorsement.expiryDate
      ? Moment(endorsement.expiryDate).format(DISPLAY_DATE_FORMAT)
      : '-';
      const disciplineColor = endorsement.endorsementStatusCode === 'ACTV' ? 'white' : 'black';   
      const isActive = endorsement.endorsementStatusCode === 'ACTV';
      const discipline = endorsement.disciplineCode.trim() === "D" ? 'Drainlayer' : 'Plumber';
      const iconPath = `/images/icon-${discipline.toLowerCase()}-${disciplineColor}.svg`;
      const status = isActive ? 'Self-certifying endorsement' : endorsement.endorsementStatusDescription;
   return (
      <div className={`endorsement-licence-card ${discipline.toLowerCase()}`}>
         <div className={`endorsement-card-top ${endorsement.endorsementStatusDescription.toLowerCase()}`}>
            <img
               className="endorsement-card-image"
               src={iconPath}
               alt={`${discipline} icon`}
            />
            <p className="endorsement-level">Certifying</p>
            <p className="endorsement-discipline">{discipline}</p>
         </div>
         <div className={`endorsement-card-bottom bottom-${endorsement.endorsementStatusDescription.toLowerCase()}`}>
            <span className="endorsement-status">{status}</span>
            <div className="endorsement-cert-logo">
               <img src="/images/icon-self-certification.png" alt="Self Certification" />
            </div>
               <div className="endorsement-status-info">
               { isActive && (
                     <div className="endorsement-expiry-row"><span className="endorsement-year">Expires: {expiryDate}</span></div>
               )}
               </div>
         </div>
      </div>
   );
};

export default EndorsementCard;
